export default __webpack_public_path__ + "static/media/copy-link.6f2234ec.svg";